import React from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {GetTheApp} from 'components/GetTheApp'
import useGenerateAppDownloadUrl from 'hooks/useGenerateAppDownloadUrl'
import {getDevicePlatform, getLanguageCode} from 'modules/meta/selectors'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {NoStyleLink} from '@vio/atlas/helpers/NoStyleLink'
import {cssTheme} from '@vio/atlas/themes'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {Placement} from '@vio/core/src/deepLinking/types'
import {
  AppleAppStoreBadge,
  GooglePlayBadge
} from '@vio/shared/src/search/footer/AppButtonsWidget/AppButtonsWidget'

const GetTheAppButton = styled(NoStyleLink)`
  margin-top: ${cssTheme.layout.spacing.s400};
`

export const GetTheAppFooterWidget = () => {
  const lang = useSelector(getLanguageCode)
  const {isDesktop} = useDeviceLayout()
  const isAndroid = useSelector(getDevicePlatform) === 'android'
  const {retention} = useBrandCapabilities()
  const {generateAppStoreDeepLink, generatePlayStoreDeepLink} =
    useGenerateAppDownloadUrl()

  if (!retention.hasGetTheApp) return null

  const handleDownloadAppLink = () => {
    const downloadAppURL = isAndroid
      ? generatePlayStoreDeepLink(Placement.Footer, undefined, lang)
      : generateAppStoreDeepLink(Placement.Footer, undefined, lang)

    window.open(downloadAppURL, '_blank')
  }

  if (isDesktop)
    return <GetTheApp dataId="desktop_footer" placement={Placement.Footer} />

  return (
    <GetTheAppButton data-id="mobile_footer" onClick={handleDownloadAppLink}>
      {isAndroid ? (
        <GooglePlayBadge lang={lang} />
      ) : (
        <AppleAppStoreBadge lang={lang} />
      )}
    </GetTheAppButton>
  )
}
